import React from "react";
import { ShieldOff } from "lucide-react";
import "./styles/BlockedUserScreen.css";

interface BlockedUserScreenProps {
  onGoBack?: () => void;
}

const BlockedUserScreen: React.FC<BlockedUserScreenProps> = ({ onGoBack }) => {
  return (
    <div className="blocked-screen">
      <div className="blocked-screen__card">
        <ShieldOff size={52} className="blocked-screen__icon" />
        <h2 className="blocked-screen__title">User Blocked</h2>
        <p className="blocked-screen__message">
          You've blocked this user. Their listings, profile, and messages are
          hidden from you.
        </p>
        {onGoBack && (
          <button className="blocked-screen__btn" onClick={onGoBack}>
            Go Back
          </button>
        )}
      </div>
    </div>
  );
};

export default BlockedUserScreen;
